export const all = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 110,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 150,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const drafts = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 130,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
    width: 50,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const requested = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 130,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
    width: 50,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const submitted = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 130,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
    width: 50,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const awarded = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 130,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
    width: 50,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Award Date',
    accessor: 'awardDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const archived = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 140,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 130,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
    width: 50,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ColumnGrids/QuotesColumns.jsx